$(document).on('click', '.ui-tooltip', function(event) {
    const target = $(this);
    
    target.toggleClass('--open');
})

$(document).on('click', function(event) {
    const target = $(event.target);
    
    if (!target.closest('.ui-tooltip').length) {
        $('.ui-tooltip').removeClass('--open');
    }
})
